import React, { Component } from 'react';
import HeaderTools from '../../PageComponents/Header/HeaderTools';
import apiService from '../../Services/apiServices';
import { useToasts } from 'react-toast-notifications'
import { confirmAlert } from 'react-confirm-alert'; 
import Search from '../../PageComponents/Search/Search';
import DataTable from '../../PageComponents/UI/Tables/DataTable';
import ImportData from '../Tools/ImportData';
import Partner from '../../Models/Partner';
import ExcelExport from '../../PageComponents/Excel/ExcelExport';
import helper from '../../Services/helper';

function withToast(Component) {
  return function WrappedComponent(props) {
      const toastFuncs = useToasts() 
      return <Component {...props} {...toastFuncs} />;
  }
}

class Partners extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allPartners: [],
      partners: [],
      partnerTypes: [],
      search:'',
      showImportData: false,
      currentFilter: '#active',
    };

    //this.search = this.search.bind(this);
    this.excelExportRef = React.createRef();
  }
  handleChange(event) {
    // Get event value
    let searchValue = event.target.value;

    // Set the state to trigger a re-rendering
    this.setState({ search: searchValue });
  }
//componentDidMount onload render data
  componentDidMount() {
      const currentFilter = this.getCurrentFilter();
      this.getPartnerTypes()
      this.setState({ currentFilter }, () => this.getPartners(currentFilter));
      window.addEventListener("hashchange", this.handleHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.handleHashChange);
  }

  showImportData = () => {
    this.setState({
      showImportData: !this.state.showImportData
    })
  }

  getPartnerTypes = () => {
    apiService().get('partnerTypes')
      .then(response => {
        if(response.success) {
          this.setState({ partnerTypes: response.data });
        }
      })
  }

  getCurrentFilter = () => {
    return window.location.hash.includes('#inactive') ? '#inactive' : '#active';
  }

  resolveFilter = (filter) => {
    return filter === '#inactive' ? '#inactive' : '#active';
  }

  normalizePartnerStatus = (status) => {
    if (status === true || status === 1 || status === '1') return 1;
    if (status === false || status === 0 || status === '0' || status === null || status === undefined || status === '') return 0;

    const numericStatus = Number(status);
    if (!Number.isNaN(numericStatus)) {
      return numericStatus > 0 ? 1 : 0;
    }

    return String(status).toLowerCase() === 'true' ? 1 : 0;
  }

  mapPartnerTypes = (partners) => {
    return partners.map((partner) => {
      const mappedPartner = { ...partner };

      if(mappedPartner.supplier === true && mappedPartner.customer === true){
        mappedPartner.pType = helper().translate("SUPPLIER") + "/"+ helper().translate("BUYER");
        mappedPartner.partnerType === 6 ?  mappedPartner.pType +=  " - " +  helper().translate("UNITY") : ""
      }else if(mappedPartner.supplier === true){
        mappedPartner.pType = helper().translate("SUPPLIER")
        mappedPartner.partnerType === 6 ?  mappedPartner.pType +=  " - " +  helper().translate("UNITY") : ""
      }else if(mappedPartner.customer === true){
        mappedPartner.pType = helper().translate("BUYER")
        mappedPartner.partnerType === 6 ?  mappedPartner.pType +=  " - " + helper().translate("UNITY") : ""
      }

      return mappedPartner;
    });
  }

  applyPartnerFilter = (partners, filter) => {
    const resolvedFilter = this.resolveFilter(filter);

    return partners.filter((partner) => {
      const normalizedStatus = this.normalizePartnerStatus(partner?.status);
      return resolvedFilter === '#inactive' ? normalizedStatus === 0 : normalizedStatus === 1;
    });
  }

  handleHashChange = () => {
    const currentFilter = this.getCurrentFilter();
    this.setState((prevState) => ({
      currentFilter,
      partners: this.applyPartnerFilter(prevState.allPartners, currentFilter)
    }));
  }

  getPartners = (filter) => {
      const resolvedFilter = this.resolveFilter(filter);
      apiService()
        // .query('partners', `status=${filter === '#active' ? 1 : 0}`)
        .get('partners')
        .then((response) => {
          if (response.success) {
            const mappedPartners = this.mapPartnerTypes(response.data || []);
            const filteredPartners = this.applyPartnerFilter(mappedPartners, resolvedFilter);

            this.setState({
              allPartners: mappedPartners,
              partners: filteredPartners,
              currentFilter: resolvedFilter
            });
          } else {
            console.log('Error:' + response.errorMessage);
          }
      });
  }

  onFieldChange = (e) => {
    this.setState({
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  edit = (item) => {
    window.location.href = `#/partner/${item.id}`
  }


  exportToExcel = () => {
    // let table = document.getElementById('table-to-xls-1').innerHTML;
    let fileName = helper().translate("PARTNERS");
    // return helper().exportToExcel(table, fileName)
    this.excelExportRef.current.exportToExcel(fileName)
  }

  delete = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui" >
            <h1>A jeni te sigurt?</h1>
            <p>Dëshironi të fshini këtë artikull?</p>
            <button
              onClick={() => {
                  apiService().delete('partners', id)
                      .then((response)=>{this.responseMessage(response, 'Delete Successfully')});
                  onClose();
              }}
            >
              Po , Fshije!
            </button>
            <button onClick={onClose}>Jo</button>
          </div>
        );
      }
    }) 
  }

  responseMessage = (response, message) => {
    let that = this;
    if(response.success){
        that.getPartners(that.state.currentFilter);
        that.props.addToast( message, { appearance: 'success', autoDismiss: true, });
     }
     else{
       that.props.addToast('Ka ndodhur nje gabim!', { appearance: 'error', autoDismiss: true, });
     }
  }

  headers = [
    { key: 'id', columnName: 'Id' },
    { key: 'companyName', columnName: 'Emri' },
    { key: 'type', columnName: 'Tipi'},
    { key: 'fiscalNo', columnName: 'NUI' },
    { key: 'customer', columnName: 'Blerës' },
    { key: 'supplier', columnName: 'Furnitor' },
    { key: 'mobilePhone', columnName: 'Kontakti' },
  ]

  exportCsv = (data) => {
     const newArr = data.map(({sid, name, surname, saveAs, phone, comment, businessNo, vatNo, address, city, partnerOrigin, createdAt, createdBy, changedAt, changedBy, status, discount, paymentTypeId, importOrLocal, branchNo, parentId, termsOfPaymentsId, cityName, country, ...rest}) => {
      return rest;
    });
    helper().exportCsv(newArr, true, 'Partners');
  }

  render() {
    let { partners } = this.state;
    let { partnerTypes } = this.state;
    let hash = this.state.currentFilter
    
    const headers = [
      { key: 'companyName', columnName: 'Emri' },
      {key: 'companyCode', columnName: helper().translate("COMPANY_CODE") },
      { key: 'pType', columnName: helper().translate("PARTNER_TYPE") },
      { key: 'fiscalNo', columnName: 'NUI' },
      { key: 'mobilePhone', columnName: 'Kontakti' }
    ]
    const headersExcel = [
      { key: 'id', columnName: 'Id' , dontShowMenu : true },
      { key: 'companyName', columnName: 'Emri' },
      { key: 'pType', columnName: helper().translate("PARTNER_TYPE") },
      { key: 'fiscalNo', columnName: 'NUI' },
      { key: 'mobilePhone', columnName: 'Kontakti' },
    ]
    let searchPartners = partners,
            searchString = this.state.search.trim().toLowerCase();

        if (searchString.length > 0) {
            // We are searching. Filter the results.
            //searchPartners = searchPartners.filter((e) => e.CompanyName.toLowerCase().match(searchString));

            searchPartners = searchPartners.filter(item => {
              return (
                item?.companyName?.toLowerCase().match(searchString) ||
                item?.saveAs?.toLowerCase().match(searchString) ||
                item?.companyCode?.toLowerCase().match(searchString) ||
                item?.pType?.toLowerCase().match(searchString) ||
                item?.fiscalNo?.toLowerCase().match(searchString) ||
                item?.mobilePhone?.toLowerCase().match(searchString)
              )
            });
        }
    return (
      <div>
      <div className="container-fluid px-2 mt-3">
        <Search new={hash ==='#active' ? "#/partner" : ''} change={(e) => this.handleChange(e)}  importData={this.showImportData} excel={() => this.exportToExcel()}/>
        <ExcelExport data={searchPartners} headers={headersExcel} type={'other'} ref={this.excelExportRef} hideContent={true} />
        <div className="card shadow mt-1">
          <div className="card-header py-2">
            <h6 className="m-0 font-weight-bold text-primary">Partneret</h6>
          </div>
          {this.state.showImportData && <ImportData queryName='partners' model={new Partner()} callBack={() => this.getPartners(this.state.currentFilter)} />}
          <DataTable headers={headers} data={searchPartners} edit={ this.edit} delete={this.delete}  />
          
        </div>
      </div>
    </div>
    );
  }
}

export default withToast(Partners);



// WEBPACK FOOTER //
// ./src/PageComponents/Items/Items.js
